import { makeStyles,theme } from '@material-ui/core/styles';

export const useStyles = makeStyles( theme=> ({
  root: {
    background: '#335267',
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]:{
      width: '100%',
      flexDirection: 'column',
     }
  },
  authBox: {
    width: 800,
    borderRadius: 3,
    height: 460,
    backgroundColor: '#fff',
    [theme.breakpoints.down('sm')]:{
     width: '90%',
     flexDirection: 'column',
    }
  },
  header: {
    width: '100%',
    height: 40
  },
  content: {
    display: 'flex',
    marginBottom: 16,
   
  },
  imageWrapper: {
    width: 400,
    height: 380,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]:{
      width: '1%'
     }
  },
  image: {
    width: '400px',
    height: '380px',
    marginLeft: '45px',
    [theme.breakpoints.down('sm')]:{
      display: 'none'
    }
  },
  contentMain: {
    width: '100%',
    padding: '0 50px',
    [theme.breakpoints.down('sm')]:{
      width: '100%',
      
      }
  },
  footer: {
    backgroundColor: '#E2EBF6',
    height: 24,
    color: '#59758B',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderBottomRightRadius: 3,
    borderBottomLeftRadius: 3,
    [theme.breakpoints.down('sm')]:{
      height: 34,
      textAlign: 'center'
      }
  }
}));

